import { FormInput } from '@form/index';
import { faServer } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Blockquote } from '@ui';
import { useClubSlug } from 'components/Clubs/hooks/useClubSlug';
import { Output } from 'components/IOT/types';
import Loader from 'components/Loader';
import { useModal } from 'hooks/useModal';
import Link from 'next/link';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

interface Props {}

export const OutputAssignField = ({}: Props) => {
    const { t } = useTranslation('iot');
    const clubSlug = useClubSlug();
    const [setModal, resetModal] = useModal();
    const { data, error } = useSWR<{ data: Output[] }>(`iot/output/club/${clubSlug}`);
    const isLoading = !data && !error;
    const name = 'outputs';
    const { control } = useFormContext();
    const {
        field: { value, onChange }
    } = useController({ name: 'outputs', control });

    const handleSelect = (output: Output) => {
        if (isSelected(output)) {
            onChange(value?.filter((o) => o !== output.id));
        } else {
            onChange([...(value ?? []), output.id]);
        }
    };

    const isSelected = (output: Output) => {
        return value?.includes(output.id);
    };

    return (
        (<Loader isLoading={isLoading}>
            {data?.data?.length > 0 ? (
                <FormInput.MultipleSelect
                    options={data.data.map((output) => ({
                        id: output.id,
                        label: output.title
                    }))}
                    name={name}
                    label={t('outputAssignField.selectLabel')}
                />
            ) : (
                <Blockquote>
                    <span className="tw-mb-3 tw-flex tw-items-center tw-text-xl">
                        <FontAwesomeIcon icon={faServer} className="mr-3" />
                        {t('outputAssignField.promoTitle')}
                    </span>
                    {t('outputAssignField.promoDescription')}
                    <Link
                        href={{ query: { tab: 'control', slug: clubSlug } }}
                        className="tw-mt-4 tw-block tw-rounded-lg tw-bg-success tw-px-2 tw-py-1 tw-text-center tw-text-white tw-transition-colors hover:tw-bg-success/90 hover:tw-text-white">

                            {t('outputAssignField.promoCta')}

                    </Link>
                </Blockquote>
            )}
        </Loader>)
    );
};
